import { createAsyncThunk } from '@reduxjs/toolkit';
import { PartnersAPI } from '@/api';
import { formatApiError } from '@/utils';
import { IApiError } from '@/models/apiError.model';
import { PARTNERS_LIST_SLICE_NAME } from './models';
import {
  ICreatePartnerDTO,
  IGetPartnersListDTO,
  IPartnerAuthData,
  IPartnerProfile,
  IPartnersListResponse,
  IUpdatePartnerDTO,
} from '@/models/partners.model';

export const getPartnersList = createAsyncThunk<
  IPartnersListResponse,
  IGetPartnersListDTO,
  { serializedErrorType: IApiError }
>(
  `${PARTNERS_LIST_SLICE_NAME}/getPartnersList`,
  async (data) => {
    const response = await PartnersAPI.getPartnersList(data);
    return response.data;
  },
  { serializeError: formatApiError },
);

export const getPartnerDetails = createAsyncThunk<IPartnerProfile, string, { serializedErrorType: IApiError }>(
  `${PARTNERS_LIST_SLICE_NAME}/getPartnerDetails`,
  async (id) => {
    const response = await PartnersAPI.getPartnerDetails(id);
    return response.data?.data;
  },
  { serializeError: formatApiError },
);

export const deletePartner = createAsyncThunk<IPartnerProfile, string, { serializedErrorType: IApiError }>(
  `${PARTNERS_LIST_SLICE_NAME}/deletePartner`,
  async (id) => {
    const response = await PartnersAPI.deletePartner(id);
    return response.data?.data;
  },
  { serializeError: formatApiError },
);

export const hidePartner = createAsyncThunk<IPartnerProfile, string, { serializedErrorType: IApiError }>(
  `${PARTNERS_LIST_SLICE_NAME}/hidePartner`,
  async (id: string) => {
    const response = await PartnersAPI.hidePartner(id);
    return response.data?.data;
  },
  { serializeError: formatApiError },
);

export const togglePartnerActive = createAsyncThunk<IPartnerProfile, string, { serializedErrorType: IApiError }>(
  `${PARTNERS_LIST_SLICE_NAME}/togglePartnerActive`,
  async (id: string) => {
    const response = await PartnersAPI.togglePartnerActive(id);
    return response.data?.data;
  },
  { serializeError: formatApiError },
);

export const updatePartnerDetails = createAsyncThunk<
  IPartnerProfile,
  IUpdatePartnerDTO,
  { serializedErrorType: IApiError }
>(
  `${PARTNERS_LIST_SLICE_NAME}/updatePartnerDetails`,
  async (data) => {
    const response = await PartnersAPI.updatePartnerDetails(data);
    return response.data?.data;
  },
  { serializeError: formatApiError },
);

export const createPartner = createAsyncThunk<IPartnerProfile, ICreatePartnerDTO, { serializedErrorType: IApiError }>(
  `${PARTNERS_LIST_SLICE_NAME}/createPartner`,
  async (data) => {
    const response = await PartnersAPI.createPartner(data);
    return response.data?.data;
  },
  { serializeError: formatApiError },
);

export const getPartnerAuthData = createAsyncThunk<IPartnerAuthData, string, { serializedErrorType: IApiError }>(
  `${PARTNERS_LIST_SLICE_NAME}/getPartnerAuthData`,
  async (id) => {
    const response = await PartnersAPI.getPartnerAuthData(id);
    return response.data;
  },
  { serializeError: formatApiError },
);

export const resendPartnerInvitation = createAsyncThunk<void, string, { serializedErrorType: IApiError }>(
  `${PARTNERS_LIST_SLICE_NAME}/resendPartnerInvitation`,
  async (id) => {
    await PartnersAPI.resendInvitation(id);
  },
  { serializeError: formatApiError },
);
